import React from 'react';
import {
  AlertTriangle, DollarSign, Layers, ClipboardList,
} from 'lucide-react';

const risks = [
  {
    icon: AlertTriangle,
    title: 'Missed Option Windows',
    description: 'Untracked renewal and ROFR windows create avoidable liability.',
  },
  {
    icon: DollarSign,
    title: 'CAM Leakage',
    description: 'Caps, exclusions, and audit rights hidden in PDFs impact NOI.',
  },
  {
    icon: Layers,
    title: 'Decentralized Tracking',
    description: 'Manual spreadsheets do not scale across portfolios.',
  },
  {
    icon: ClipboardList,
    title: 'No Verification Record',
    description: 'No structured log of status changes, waivers, or expirations.',
  },
];

export function RiskSection(): JSX.Element {
  return (
    <section id='risk' className='py-24 md:py-32'>
      <div className='mx-auto max-w-6xl px-6'>
        <div className='mx-auto max-w-2xl text-center'>
          <h2
            className='text-3xl font-bold tracking-tight text-foreground md:text-4xl text-balance'
            style={{ fontFamily: 'var(--font-heading)' }}
          >
            Lease Exposure Is Financial Risk.
          </h2>
        </div>

        <div className='mt-16 grid gap-8 md:grid-cols-2 lg:grid-cols-4'>
          {risks.map((risk) => (
            <div
              key={risk.title}
              className='group rounded-2xl border border-border bg-card p-8 transition-all hover:shadow-lg hover:border-teal/40'
            >
              <div className='flex h-12 w-12 items-center justify-center rounded-xl bg-teal/20'>
                <risk.icon className='h-6 w-6 text-foreground' />
              </div>
              <h3 className='mt-6 text-lg font-semibold text-foreground' style={{ fontFamily: 'var(--font-heading)' }}>
                {risk.title}
              </h3>
              <p className='mt-3 text-sm leading-relaxed text-muted-foreground'>
                {risk.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
